import type { ReactNode } from 'react';

export const symbol_view_stream: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M780-260v-190H180v190h600Zm0-250v-190H180v190h600ZM180-200q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h600q24 0 42 18t18 42v440q0 24-18 42t-42 18H180Z"
		/>
	</svg>
);
